/*
 * Driver App Container
 *
 * Entry point for the driver-facing app at /driver.
 * Manages driver authentication state (separate driverToken in localStorage)
 * and switches between the login screen and the driver dashboard.
 */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../../utils/config';
import DriverLogin from './DriverLogin';
import DriverDashboard from './DriverDashboard';

const DriverApp = () => {
  const [driver, setDriver] = useState(null);
  const [loading, setLoading] = useState(true);

  // Restore session from stored token on mount
  useEffect(() => {
    const restore = async () => {
      const token = localStorage.getItem('driverToken');
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const response = await axios.get(`${API}/driver/me`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        setDriver(response.data);
      } catch (err) {
        localStorage.removeItem('driverToken');
        localStorage.removeItem('driverInfo');
      } finally {
        setLoading(false);
      }
    };
    restore();
  }, []);

  const handleLogin = (driverData, token) => {
    localStorage.setItem('driverToken', token);
    localStorage.setItem('driverInfo', JSON.stringify(driverData));
    setDriver(driverData);
  };

  const handleLogout = () => {
    localStorage.removeItem('driverToken');
    localStorage.removeItem('driverInfo');
    setDriver(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="text-4xl mb-2">🚛</div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!driver) {
    return <DriverLogin onLogin={handleLogin} />;
  }

  return <DriverDashboard driver={driver} onLogout={handleLogout} />;
};

export default DriverApp;
